export const LOGIN = "auth/login-merchant";
export const REFRESH_TOKEN = "/auth/refresh";
export const LOGOUT = "/auth/refresh-revoke";
export const APP_COUNT = "merchant/application-count";
export const SEND_OTP = "merchant/initiate-application";
export const VERIFY_OTP = "merchant/verify-otp";
export const APP_LIST_RECV = "merchant/application-list/received";
export const APP_LIST_COMP = "merchant/application-list/completed";
export const APP_LIST_PEND = "merchant/application-list/pending";
export const APP_LIST_REJ = "merchant/application-list/rejected";
export const SELECT_PRODUCT = "merchant/select-product";
export const CD_LOAN_OFFER = "merchant/cd-loan-offers";
export const SELECT_OFFER = "merchant/select-offer";
export const SEARCH_PRODUCT = "merchant/search-product";
export const OFFER_SUMMARY = "merchant/offer-summary";
export const VERIFY_IMEI = "merchant/verify-imei";
export const VERIFY_IMEI_DOWNPAYMENT = "merchant/verify-imei-downpayment";
export const CHANGE_PRODUCT = "merchant/change-product";

// P2p API
export const API = process.env.REACT_APP_BASE_V3_API_URL;
export const PGAPI = process.env.REACT_APP_BASE_LL_URL;

export const CUSTOMER_DETAILS_LANDING =
  "/p2p/get-customer-detail?landing_page=";
export const VERYFY_NUMBER = "/p2p/request-otp";
export const P2P_LOGIN = "/p2p/login";

// dashboard url extensions
export const PORTFOLIO = "/p2p/investment-dashboard"; //changed to investment-summary from port-folio summary
export const INVESTMENT_SUMMARY = "/p2p/investment-summary"; //new api
export const CASH_LEDGER = "/p2p/cash-ledger"; //new api

export const WITHDRAW_MONEY_URL = "/p2p/withdraw-money";
export const ADD_MONEY_URL = "/p2p/add-money-investor-offline"; //for NEFT
export const GATEWAY_MONEY_URL = "/p2p/create-investment-payment-gateway"; // gateway payment
export const HANDLE_REFERRAL_URL = "/p2p/handle-referral";
export const LEGAL_AUTH = "/p2p/legal-authorization";

// payment gateway LL api
// export const LLAPI = process.env.REACT_APP_BASE_LL_URL;
export const PAYRESP = "/payment-response";
export const CONFIRM_TRANSACTION = "/p2p/update-transaction";
export const LLAPIURL = "/p2p/create-investment-payment-gateway";

// ldc p2p
export const LDC_CREATE_USER = "/p2p/signup";
export const LDC_VERIFY_USER = "/p2p/verify-user";
export const FETCH_KYC_BACKEND = "/p2p/fetch-kyc-backend";

// personal information
export const PERSONAL_INFO_USER = "/p2p/register-user";
export const PERSONAL_INFO_SEND_DETAILS = "/p2p/detail-log";
export const REGISTER_CUSTOMER = "/p2p/register-stashfin-customer";
export const PERSONAL_FETCH_KYC = "/p2p/fetch-ckyc";

// connect bank
export const UPDATE_BANK_DETAILS = "/p2p/update-bank-details";
export const BANK_ACCOUNT_DETAILS = "/p2p/bank-account-details";
export const REGISTER_CLIENT_USER = "/p2p/register-client-user";
export const CONNECT_BANK_FETCH_IFSC = "https://ifsc.razorpay.com/";
export const INVESTOR_DOCS = "/p2p/complete-verification";

// manual kyc
export const MANUAL_KYC_API = "/p2p/manual-kyc";

// manual kyc
export const ADHARCARD_FETCH_API = "/p2p/fetch-adharcard";

// Refer Earn
export const GET_REFERRAL_CODE_URL = "/p2p/get-referral-code";
export const REFERRAL_URL = process.env.REACT_APP_BASE_REFERRAL_URL;
export const ENCRYPTED_URL = process.env.REACT_APP_ENCRYPTED_KEY_URL;

// lender t&c
export const GET_LENDER_AGREEMENT = "/p2p/get-partner-tnc";
export const UDPDATE_TERMS = "/p2p/update-tnc";

// BORROWER
export const GET_BORROWER_URL = "/p2p/borrower-details";

// ticket
export const RAISE_TICKET = "/p2p/create-ticket";
